<template>
	<div class="content-wrapper">
		<div class="sf-flex-column">
			<div class="sf-col-5">
				<el-row :gutter="30">
					<el-col :span="12">
						<sf-card class="p-0 border-0 bg-transparent" height="320px">
							<pc-pcm-regn-tap-3-table-1 class="p-0 border-0 bg-transparent" ref="table" :scrId="scrId"></pc-pcm-regn-tap-3-table-1>
						</sf-card>
					</el-col>
					<el-col :span="12">
						<sf-card class="p-0 border-0 bg-transparent" height="320px">
							<pc-pcm-regn-tap-3-table-2 class="p-0 border-0 bg-transparent" ref="table" :scrId="scrId"></pc-pcm-regn-tap-3-table-2>
						</sf-card>
					</el-col>
				</el-row>
			</div>
		</div>
	</div>
</template>

<script>
import PcPcmRegnTap3Table1 from './PcPcmRegnTap3Table1.vue';
import PcPcmRegnTap3Table2 from './PcPcmRegnTap3Table2.vue';

export default {
	props: {
		scrId: { type: String, default: '' }
	},
	data() {
		return {};
	},
	created() {},
	components: { PcPcmRegnTap3Table1, PcPcmRegnTap3Table2 },
	methods: {}
};
</script>

<style></style>
